const COMPARE_IMG =
  'https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20of%20three%20manga%20comic%20panel%20quality%20levels%20from%20high%20detail%20original%20to%20lightweight%20compressed%20version%2C%20emerald%20green%20data%20saving%20theme%2C%20clean%20minimal%20flat%20illustration%2C%20soft%20background&width=1200&height=700&seq=quality-compare-2026&orientation=landscape';

const ROWS = [
  { label: '原图画质', size: '每章约 20MB', note: '画质最高，流量消耗最大', active: false },
  { label: '压缩图模式', size: '每章约 10MB', note: '细节几乎无损，体积减半', active: true },
  { label: '省流画质', size: '每章约 7MB', note: '优先省流量，观感流畅', active: true },
];

const STATS = [
  { icon: 'ri-arrow-up-line', color: 'bg-primary-500', num: '50%+', label: '图片体积下降' },
  { icon: 'ri-timer-line', color: 'bg-accent-500', num: '1.6×', label: '加载速度提升' },
  { icon: 'ri-phone-line', color: 'bg-secondary-500', num: '62%', label: '月流量可节省' },
];

export default function Comparison() {
  return (
    <section id="compare" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div className="relative">
            <img
              src={COMPARE_IMG}
              alt="漫画人极速版省流画质与压缩图模式的画质对比"
              className="w-full rounded-lg border border-background-200 object-cover"
            />
            <div className="absolute -bottom-5 left-4 rounded-md bg-background-50 px-3 py-2 text-xs font-medium text-foreground-700 shadow-sm md:left-6">
              <i className="ri-file-reduce-line text-primary-600"></i> 同源画质，更小体积
            </div>
          </div>

          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-bar-chart-box-line"></i>
              流量对比
            </span>
            <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">
              开启数据节省，流量真的省下来
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              同样一部漫画，不同模式下的单章体积相差明显。漫画人极速版通过省流画质与压缩图模式，
              让低流量浏览也能拥有流畅体验。
            </p>

            <div className="mt-6 space-y-3">
              {ROWS.map((row) => (
                <div
                  key={row.label}
                  className={`flex flex-wrap items-center justify-between gap-2 rounded-md border px-4 py-3 ${
                    row.active
                      ? 'border-primary-200 bg-primary-50/60'
                      : 'border-background-200 bg-background-100'
                  }`}
                >
                  <span className="flex items-center gap-2 text-sm font-medium text-foreground-900">
                    {row.active && <i className="ri-checkbox-circle-fill text-primary-500"></i>}
                    {!row.active && <i className="ri-subtract-line text-foreground-400"></i>}
                    {row.label}
                  </span>
                  <span className="text-sm font-bold text-foreground-950">{row.size}</span>
                  <span className="w-full text-xs text-foreground-500 md:w-auto">{row.note}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-3 md:mt-20 md:gap-5">
          {STATS.map((s) => (
            <div
              key={s.label}
              className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6"
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-md text-background-50 ${s.color}`}>
                <i className={`${s.icon} text-xl`}></i>
              </span>
              <div>
                <p className="font-heading text-2xl text-foreground-950 md:text-3xl">{s.num}</p>
                <p className="mt-1 text-xs text-foreground-600 md:text-sm">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}